import { StoreAction, XmAction } from 'store/actions';
import { LocationCollection } from './models';

export function cbmlocationReducer(state: LocationCollection, action: XmAction<LocationCollection>): LocationCollection {
    switch (action.type) {
        case StoreAction.GET_SWITCH_LOCATIONS:
            return action.payload;
        case StoreAction.CLEAR_SWITCH_LOCATIONS:
            return undefined;
        default:
            return state;
    }
}
